export enum ESubscriptionIssue {
    INCOMPLETE_DOCUMENTS = 'INCOMPLETE_DOCUMENTS',
    INCORRECT_DOCUMENTS = 'INCORRECT_DOCUMENTS',
    EXPIRED_DOCUMENTS = 'EXPIRED_DOCUMENTS',
    MISSING_INFORMATION = 'MISSING_INFORMATION',
    DUPLICATE_SUBMISSION = 'DUPLICATE_SUBMISSION',
    INELIGIBLE_USER = 'INELIGIBLE_USER',
    OTHER = 'OTHER'
}
